import React from 'react';

import viewTokens from '@amzn/meridian-tokens/base/icon/view';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Tooltip from '@amzn/meridian/tooltip';

import { ColDef } from 'ag-grid-community';
import { getTerritoryFlagRenderer } from 'src/util/grid/cellRenderer';

export const getRawCalculationColDefs = (
    showRoyaltyDetails: (row: any) => void,
    isRoyaltyDataLoaded: boolean
): ColDef[] => [
    { field: 'service', headerName: 'Service', wrapText: true, autoHeight: true },
    {
        field: 'territory',
        headerName: 'Territory',
        cellRenderer: getTerritoryFlagRenderer,
        cellStyle: { display: 'flex', alignItems: 'center' }
    },
    { field: 'entity', headerName: 'Entity', wrapText: true, autoHeight: true },
    { field: 'month', headerName: 'Month', wrapText: true, autoHeight: true },
    { field: 'catalogVendorCode', headerName: 'Catalog Vendor Code', wrapText: true, autoHeight: true },
    { field: 'royaltyVendorCode', headerName: 'Royalty Vendor Code', wrapText: true, autoHeight: true },
    { field: 'currency', headerName: 'Currency', wrapText: true, autoHeight: true },
    {
        field: 'amount',
        headerName: 'Amount',
        wrapText: true,
        autoHeight: true,
        valueFormatter: (params) => {
            if (params.value == null) return '';
            return typeof params.value === 'number' ? params.value.toFixed(2) : params.value;
        }
    },
    {
        headerName: 'Actions',
        field: 'actions',
        cellRenderer: (params: any) => (
            <Column height="100%" alignmentVertical="center">
                <Tooltip title="View Royalties" position="top">
                    <Button
                        aria-label="view royalty details"
                        type="link"
                        size="small"
                        disabled={!isRoyaltyDataLoaded}
                        onClick={() => showRoyaltyDetails(params.data)}
                    >
                        <Icon className="button-icon" tokens={viewTokens} />
                    </Button>
                </Tooltip>
            </Column>
        ),
        width: 120,
        pinned: 'right',
        sortable: false,
        filter: false,
        suppressSizeToFit: true
    }
];
